export function normalizeExternalUrl(value) {
  const text = String(value || '').trim()
  if (!text) return null
  if (!/^https?:\/\//i.test(text)) return null
  try {
    const url = new URL(text)
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null
  } catch {
    return null
  }
}

export function getToolExperienceUrl(tool) {
  if (!tool) return null
  const candidates = [
    tool.demo_url,
    tool.demoUrl,
    tool.homepage_url,
    tool.homepageUrl,
    tool.homepage,
    tool.website,
    tool.url,
    tool.github_url,
    tool.githubUrl,
    tool.repo_url,
    tool.repoUrl,
    tool.html_url,
    tool.htmlUrl,
    tool.source_url,
    tool.sourceUrl,
    tool.download?.sourceUrl,
  ]
  for (const candidate of candidates) {
    const url = normalizeExternalUrl(candidate)
    if (url) return url
  }
  return null
}

export function openToolExperience(tool, {
  onBlocked,
  onFallback,
  onInvalid,
  onMissing,
  onOpened,
} = {}) {
  const directUrl = normalizeExternalUrl(tool?.demo_url || tool?.demoUrl)
  const url = getToolExperienceUrl(tool)
  if (!url) {
    onMissing?.()
    return false
  }

  if (!directUrl) onFallback?.(url)

  try {
    const opened = window.open(url, '_blank', 'noopener,noreferrer')
    if (!opened) {
      onBlocked?.()
      return false
    }
    onOpened?.(url)
    return true
  } catch {
    onInvalid?.()
    return false
  }
}

export function translatedExperienceText(t, key, fallback) {
  const value = typeof t === 'function' ? t(`tools.${key}`) : ''
  return value && value !== `tools.${key}` ? value : fallback
}
